export enum TourSoundTypeEnum {
  SOUND = 'SOUND',
  TOUR_GUIDE = 'TOUR_GUIDE',
  BG_SOUND = 'BG_SOUND',
}
